import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-white" data-id="element-7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-9">
          <div className="mb-12 lg:mb-0" data-id="element-10">
            <div className="z-10 text-center" data-id="element-11">
              <div className="text-6xl font-bold text-blue-900 mb-2" data-id="element-12">15+</div>
              <div className="text-slate-500 font-medium uppercase tracking-widest" data-id="element-13">
                Jahre Erfahrung
              </div>
              <div className="text-6xl font-bold text-blue-900 mb-2" data-id="element-14">60+</div>
              <div className="text-slate-500 font-medium uppercase tracking-widest" data-id="element-15">
                erfolgreiche Projekte
              </div>
            </div>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-16"></p>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-17">
              Seit über 15 Jahren begleiten wir führende Banken und
              Industrieunternehmen bei der Umsetzung kritischer Großprojekte.
              Unser Ansatz verbindet klassische Methodik mit agiler
              Flexibilität.
            </p>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-18">
              Wir verstehen nicht nur die Theorie, sondern kennen die
              politischen und strukturellen Herausforderungen in Konzernen aus
              erster Hand.
            </p>

            <div className="space-y-4" data-id="element-19">
              {['Zertifizierte Senior-Berater (PMP, Prince2, SAFe)', 'Nachweisbare Erfolge in komplexen IT-Migrationen', 'Branchenfokus auf Finance, Telco und Verwaltung', 'Pragmatische Lösungsfindung statt theoretischer Konzepte'].map((item, index) => <div key={index} className="flex items-start" data-id="element-20">
                  <CheckCircle2 className="h-6 w-6 text-blue-600 mr-3 flex-shrink-0" data-id="element-21" />
                  <span className="text-slate-700" data-id="element-22">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-23">
            <div className="rounded-2xl overflow-hidden bg-white shadow-xl border border-slate-200" data-id="element-24">
              <img src="https://cdn.magicpatterns.com/uploads/j2Gvr8xBRrQ5YM6L2XUyqm/Uwe-ganz-260204.jpg" alt="Uwe Ellner - Projektmanagement Experte" className="w-full h-auto object-cover" data-id="element-25" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-blue-100 rounded-full -z-10" data-id="element-26" />
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-slate-50 rounded-full -z-10" data-id="element-27" />
          </div>
        </div>
      </div>
    </section>;
}